import React from 'react';
import { object, string, bool, shape, number, arrayOf, func } from 'prop-types';

import { overallComposite as overallCompositePropType } from '../propTypes';

import PayElementDropdown from '../PayElementDropdown/PayElementDropdown';
import YearOverYearChart from '../YearOverYearChart/YearOverYearChart';
import PayElementsAtTargetTable from '../PayElementTables/PayElementAtTargetTable/PayElementsAtTargetTable';
import SinglePayElementAtTargetTable from '../PayElementTables/PayElementAtTargetTable/SinglePayElementAtTargetTable';

import './OverallComposites.scss';
class OverallComposites extends React.PureComponent {
  static propTypes = {
    data: overallCompositePropType,
    actions: object,
    selectedPayElement: string,
    hideJobCodeKey: bool,
    jobCodeKeyText: string,
    selectedOrgJob: shape({
      code: string,
      codeKey: string,
      id: string,
      title: string
    }),
    showAsPercentage: bool,
    payElementLabels: shape({
      baseSalary: string,
      totalCash: string,
      totalTargetCash: string,
      totalDirect: string,
      totalGuaranteedPay: string
    }),
    chartData: shape({
      xAxisLabels: arrayOf(string),
      seriesName: string,
      seriesDataValues: arrayOf(
        shape({
          name: string,
          y: number
        })
      ),
      showAsPercentage: bool,
      toggleAction: func
    }),
    isPdf: bool,
    showOverallComposites: bool
  };

  getAllNullDataRender() {
    const { data } = this.props;

    return (
      <div className="overall-composites__content">
        <div className="overall-composites__no-data">
          <div>
            <h3 className="pxl-text-body overall-composites__no-data-header">
              {`No Overall Composite Data in ${data.baseSalary.prevPrevYear.label} - ${data.baseSalary.currentYear.label}`}
            </h3>
            <p className="pxl-text-small overall-composites__no-data-text">
              Please change benchmark year to see Overall Composite data
            </p>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      selectedPayElement,
      payElementLabels,
      actions,
      data,
      chartData,
      showAsPercentage,
      isPdf,
      showOverallComposites
    } = this.props;
    const { metadata } = data;
    if (!isPdf && metadata.isAllNull) {
      return this.getAllNullDataRender();
    }

    return (
      <React.Fragment>
        {!isPdf && (
          <div className="overall-composites__header">
            <PayElementDropdown
              showOverallComposites={showOverallComposites}
              selectedPayElement={selectedPayElement}
              payElements={payElementLabels}
              onElementClick={actions.selectPayElement}
            />
          </div>
        )}
        <div className="overall-composites__content">
          <div className="overall-composites">
            <SinglePayElementAtTargetTable
              pricingData={metadata.pricingData}
              data={data[selectedPayElement]}
              monetaryRounding={data.monetaryRounding}
              percentRounding={data.percentRounding}
            />
            <hr className="year-over-year__divider" />
            <YearOverYearChart
              className="overall-composite__chart"
              xAxisLabels={chartData.categories}
              seriesName={chartData.seriesName}
              seriesDataValues={chartData.data}
              showAsPercentage={showAsPercentage}
              toggleAction={actions.toggleShowAsPercentage}
            />
            <PayElementsAtTargetTable
              showOverallComposites={showOverallComposites}
              data={data}
              monetaryRounding={data.monetaryRounding}
              percentRounding={data.percentRounding}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default OverallComposites;
